module.exports = {
      id: "404-robot-usage",
      viewBox: "0 0 280 313",
      url: __webpack_public_path__ + "svg-sprite-f952e3bcb1151291994742cd359b350c.svg#404-robot",
      toString: function () {
        return this.url;
      }
    }